"use strict";

export default function(qty,pricing){
    qty = Number(qty);
    if(!qty)
        return null;
    var i = pricing.length;
    while(i--){
        if(Number(pricing[i]['qty'])<=qty){
            return Number(pricing[i]['price']);
        }
    }
};
